import {QRCodeGenerator, QRCode} from '../helpers/qrcode';
var isQRCodeGenerated = false;

export function vtoSetup() {
    let vtoBtn = document.querySelector('.vto-badge');

    if (vtoBtn) {
        vtoBtn.addEventListener('click', function() {
            let vtoURL = vtoBtn.getAttribute('data-vto-url');
            let origin = window.location.href;
            // replace origin in vtoURL
            vtoURL = vtoURL.replace(new RegExp('{origin}', 'g'), origin);
            let isMobile = $(window).width() <= 480 ? true : false;
            if (isMobile) {
                window.open(vtoURL, '_blank');
                return;
            }
            // generate QR code
            let vtoQrContainer = document.querySelector('.vto__qr-container');
            let vtoQrImage = document.querySelector('.vto-qr-code');
            let vtoQrClose = document.querySelector('.vto-qrcode-close');
            if (!isQRCodeGenerated) {
                QRCodeGenerator();
                var qrcode = new QRCode(vtoQrImage, {
                    width: 180,
                    height: 180
                });
            }
            if (vtoURL) {
                if (!isQRCodeGenerated) {
                    qrcode.makeCode(vtoURL);
                    isQRCodeGenerated = true;
                }
                vtoQrContainer.classList.remove('hidden');
                vtoBtn.classList.add('hidden');
                vtoQrClose.addEventListener('click', function() {
                    vtoQrContainer.classList.add('hidden');
                    vtoBtn.classList.remove('hidden');
                })
            }
        });
    }
}
